import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var _types$SET_LOOKBOOK$t;

import * as types from './types';
export default (_types$SET_LOOKBOOK$t = {}, _defineProperty(_types$SET_LOOKBOOK$t, types.SET_LOOKBOOK, function (state, payload) {
  var currentState = state;
  currentState.lookbook = payload;
}), _defineProperty(_types$SET_LOOKBOOK$t, types.APPEND_AMBIENCES, function (state, payload) {
  var currentState = state;
  var ambiences = currentState.lookbook.items;
  currentState.lookbook.items = [].concat(_toConsumableArray(ambiences), _toConsumableArray(payload.items));
}), _defineProperty(_types$SET_LOOKBOOK$t, types.PREPEND_AMBIENCES, function (state, payload) {
  var currentState = state;
  var ambiences = currentState.lookbook.items;
  currentState.lookbook.items = [].concat(_toConsumableArray(payload.items), _toConsumableArray(ambiences));
}), _defineProperty(_types$SET_LOOKBOOK$t, types.SET_LOADING_AMBIENCES, function (state, payload) {
  var currentState = state;
  currentState.loading = payload;
}), _types$SET_LOOKBOOK$t);